import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';

export const StyledSuccessInfo = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
